<div
  data-test="f1meEBR-"
  class="modal modal-right"
  id="add-permission-role"
  [class.active]="active"
>
  <div data-test="iyxcmkY0" class="modal__overlay" data-close="modal"></div>
  <div data-test="Z-db5EKv" class="modal__wrap">
    <div data-test="myeEuGKv" class="modal__window">
      <div data-test="zKGBYtVU" class="modal__content pb-0">
        <button
          data-test="79VM8cSb"
          (click)="handleCloseClick()"
          class="modal__close"
          data-close="modal"
        >
          <span data-test="07P9zRMu" class="badge badge_gray">
            <i data-test="jUZl17ci" class="material-icons md-12">close</i>
          </span>
        </button>
        <div
          data-test="Fq8cYscu"
          class="modal__content-wrap scrollbar-hidden"
          data-simplebar="init"
        >
          <div
            data-test="OkrI2Eov"
            class="simplebar-track vertical"
            style="visibility: visible"
          >
            <div
              data-test="Me6UKleV"
              class="simplebar-scrollbar"
              style="visibility: visible; top: 0px; height: 25px"
            ></div>
          </div>
          <div
            data-test="bvu-jFl7"
            class="simplebar-track horizontal"
            style="visibility: visible"
          >
            <div
              data-test="prSQRPuy"
              class="simplebar-scrollbar"
              style="visibility: visible; left: 0px; width: 25px"
            ></div>
          </div>
          <div
            data-test="gISg-g4s"
            class="simplebar-scroll-content"
            style="padding-right: 17px; margin-bottom: -34px"
          >
            <div
              data-test="E32Vhnxc"
              class="simplebar-content"
              style="padding-bottom: 17px; margin-right: -17px"
            >
              <div data-test="SwT0nsoB" class="modal__container">
                <div data-test="SkPyDOd2" class="modal__body">
                  <h2 data-test="v7lwgsnl" class="modal__title h1">
                    <span data-test="xCtaBxoR" class="text-figure-left">
                      <span data-test="vGoDDzoq" class="text-figure-left__text">
                        Add permission role
                      </span>
                    </span>
                  </h2>
                  <form data-test="CIr05-hA" class="form mb-0">
                    <div data-test="o3wHtC_g" class="form-group">
                      <div data-test="tsPQr-r6" class="row flex-nowrap">
                        <div data-test="56s-i5nk" class="col-auto mr-auto">
                          <label data-test="oLizzexw" class="form-group__label">
                            Permission role
                          </label>
                        </div>
                      </div>
                      <div
                        data-test="CVam_8vg"
                        class="form-group__field form-group__field_append"
                      >
                        <input
                          data-test="NaPjZbxw"
                          readonly
                          (keyup)="onKeyUp($event)"
                          class="input dropdown-focus"
                          id="dd-permission-role"
                          type="text"
                          placeholder="Select permission role"
                          value="{{ newRole?.name }}"
                        />
                        <label
                          data-test="J7PoKrY7"
                          class="form-group__field-append link-light"
                          for="dd-permission-role"
                        >
                          <i data-test="OVeZYCl1" class="material-icons md-16">
                            keyboard_arrow_down
                          </i>
                        </label>
                        <div
                          data-test="aGqmE7qT"
                          class="dropdown w-100 pt-0"
                          id=""
                          *ngIf="roles && roles.length > 0"
                        >
                          <div data-test="xjQDrJjj" class="dropdown__wrap">
                            <ul data-test="PPoRLzuQ" class="dropdown__menu">
                              <li
                                data-test="w28mYvvV"
                                (mousedown)="handleRoleSelect(role)"
                                class="dropdown__menu-item"
                                *ngFor="let role of roles; trackBy: trackControl"
                              >
                                <a data-test="xapPYf2q" class="dropdown__menu-link">
                                  {{ role?.name }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <md-permissions-table
                    data-test="TGFzFUpL"
                    *ngIf="permissions"
                    [tab]="'add-role'"
                    [permissions]="permissions"
                  ></md-permissions-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer data-test="N7kcmi3r" class="modal__footer">
          <div data-test="YMshPCQE" class="modal__container">
            <div data-test="YTbt6-Ti" class="modal__footer-wrap row gutters-20">
              <div data-test="IGohZkd6" class="col-auto">
                <button
                  data-test="_gwQqqAQ"
                  class="button button_secondary"
                  (click)="handleCloseClick()"
                  data-close="modal"
                >
                  Cancel
                </button>
              </div>
              <div data-test="MgtJVpCg" class="col-auto">
                <button
                  data-test="b-403OaB"
                  (click)="addNew()"
                  class="button button_primary"
                  data-save="modal"
                  data-close="modal"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
